import React, { useState, useEffect } from "react" ;
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getMyPosts } from "root/DataFunctions/ChildDataFns";
import ChildPost from "../Components/ChildPost";
import Loading from "../Components/Loading";
import ChildPostDetailNew from "../Components/ChildPostDetailNew";
import '../styles/Layout/postsDashboard.scss';
import {useRecoilValue} from "recoil";
import {childDetailsState} from "root/recoil/childDetailsState";

const PostsDashboard = () => {
    const [allPosts, setAllPosts] = useState(null);
    const [index, setIndex] = useState(null);
    const filteredPost = allPosts ? allPosts[index] : '';
    const childDetails = useRecoilValue(childDetailsState);

    // Loop posts array
    const checkNumber = (number) => {
        if(number > allPosts.length - 1) {
            return 0;
        }
        if (number < 0) {
            return allPosts.length - 1;
        }
        return number;
    }
    
    const onNextPost = () => {
        setIndex((index) => {
            let newIndex = index + 1;
            return checkNumber(newIndex);
        })
    }
    
    const onPrevPost = () => {
        setIndex((index) => {
            let newIndex = index - 1;
            return checkNumber(newIndex);
        })
    }

    const onSetIndexFromPost = (indx) => {
        setIndex(indx)
    }

    useEffect(()=>{
        
        getMyPosts(response =>
        {
            setAllPosts(getDataFromResponse(response));
        });
    
    }, [])

    const postsTitle = () => {

        let firstname = '';

        if(childDetails){
            if(childDetails[0].description === null || childDetails[0].description === ''){
                firstname = childDetails[0].adopted_firstname !== null ? childDetails[0].adopted_firstname : childDetails[0].firstname;
            }
            else{
                firstname = childDetails[0].description;
            }
        }

        const title = 'Hi ' + firstname + ' - Latest Posts'
        return title;
    }

    return (
        <>
            <div style={{display: "flex", flexDirection: "column", flex: "1"}}>
                <div className="child_breadcrumb child_breadcrumb-main">
                    <div className="child_breadcrumb_inner">
                        <h2 className="child_breadcrumb_title">{postsTitle()}</h2>
                    </div>
                </div>
                <div className="child-post-items">
                    {allPosts 
                        && index !== null 
                        && <ChildPostDetailNew totalPost={allPosts.length} index={index} filteredPost={filteredPost} nextPost={onNextPost} prevPost={onPrevPost} setIndex={setIndex} postStatus={'incomming'}/>
                    }
                    {allPosts 
                        ? allPosts.map( (post, i) =>
                            <ChildPost
                                key={post.post_id}
                                post={post}
                                setIndexFromPost={onSetIndexFromPost}
                                postIndex={i}
                                postStatus={'incomming'}
                            /> )
                        : <Loading />
                    }
                </div>
            </div>
        </>
    );
}

export default PostsDashboard;
